import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import { Button } from '../../../subkit-ui';
import { TWInput } from '../../TWInput';
import { serviceLeadCreated } from '../../../utils/segmentAnalytics';
import { validateEmail } from '../../../utils/helpers';
import classNames from 'classnames';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var ServiceNewsletter = function ServiceNewsletter(_ref) {
  var providerService = _ref.providerService,
      createServiceProspect = _ref.createServiceProspect,
      currentUser = _ref.currentUser,
      serviceProspectExists = _ref.serviceProspectExists,
      redirectBack = _ref.redirectBack;
  var userEmail = currentUser ? currentUser.email : '';

  var _useState = useState(userEmail),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = useState(validateEmail(userEmail)),
      isValid = _useState2[0],
      setValid = _useState2[1];

  useEffect(function () {
    if (userEmail) {
      setEmail(userEmail);
      setValid(validateEmail(userEmail));
    }
  }, [userEmail]);

  var handleEmailChange = function handleEmailChange(event) {
    var value = event.target.value;
    setEmail(value);
    setValid(validateEmail(value));
  };

  var handleSubscribe = function handleSubscribe() {
    var _location;

    createServiceProspect(_objectSpread({
      email: email,
      serviceId: providerService.id
    }, redirectBack ? {
      redirect: encodeURIComponent((_location = location) === null || _location === void 0 ? void 0 : _location.href)
    } : {})).then(function (prospect) {
      return prospect && serviceLeadCreated({
        providerService: providerService,
        currentUser: currentUser
      });
    });
  };

  var loading = !providerService;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      className: "mt-2 pb-4 sm:mt-3 sm:pb-5 lg:pb-7",
      children: /*#__PURE__*/_jsx("div", {
        className: "relative",
        children: /*#__PURE__*/_jsx("div", {
          className: "relative w-full mx-auto px-2 sm:px-4 xl:px-8",
          children: /*#__PURE__*/_jsxs("div", {
            className: "w-full xl:w-11/12 bg-white mx-auto rounded-lg shadow-card overflow-hidden md:flex",
            children: [/*#__PURE__*/_jsxs("div", {
              className: classNames('flex-1 flex flex-col justify-center bg-white lg:p-12 px-6 pt-8 pb-0', {
                'md:pb-8': !serviceProspectExists || !userEmail
              }),
              children: [/*#__PURE__*/_jsxs("h3", {
                className: "mb-2 mt-0 text-2xl font-extrabold text-gray-900 capitalize sm:text-3xl",
                children: [providerService.name, " Newsletter"]
              }), /*#__PURE__*/_jsxs("p", {
                className: classNames('mt-1 text-base text-gray-500', {
                  'mb-0': !serviceProspectExists || !userEmail
                }),
                children: [' ', "Get occasional updates from ", /*#__PURE__*/_jsx("span", {
                  className: "capitalize",
                  children: providerService.name
                }), " in your inbox"]
              }), !serviceProspectExists && !userEmail && /*#__PURE__*/_jsx("div", {
                className: "w-full md:w-2/3 lg:w-2/3 mt-5",
                children: /*#__PURE__*/_jsx(TWInput, {
                  label: "Email Address",
                  onChange: handleEmailChange,
                  type: "email",
                  dataCy: "newsletter-email-address"
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: classNames('w-full md:w-80 pt-4 pb-8 py-8 px-6 text-center bg-white lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12', {
                'md:pt-8': !serviceProspectExists || !userEmail
              }),
              children: [!serviceProspectExists || !userEmail && /*#__PURE__*/_jsx("div", {
                className: "mt-4 flex items-center justify-center text-4xl font-extrabold text-gray-900",
                children: /*#__PURE__*/_jsx("span", {
                  children: "Free"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: classNames({
                  'mt-0 md:mt-6': !serviceProspectExists
                }),
                children: /*#__PURE__*/_jsx("div", {
                  className: "rounded-md shadow",
                  children: /*#__PURE__*/_jsx(Button, {
                    text: serviceProspectExists ? 'Subscribed' : 'Subscribe',
                    size: "lg",
                    disabled: !isValid || serviceProspectExists || loading,
                    onClick: handleSubscribe,
                    "data-cy": "ServiceNewsletterCTA"
                  })
                })
              })]
            })]
          })
        })
      })
    })
  });
};